import { FrequentServicesIdEnum } from '@client-monorepo/common/service-data';

export const SERVICE_ROUTES: { [key in FrequentServicesIdEnum]: string } = {
  [FrequentServicesIdEnum.TOPUP]: 'top-up',
  [FrequentServicesIdEnum.BUNDLE]: 'internet',
  [FrequentServicesIdEnum.C2C]: 'service/c2c',
  [FrequentServicesIdEnum.BILL]: 'bill',
  [FrequentServicesIdEnum.TAXI]: 'qr',
  [FrequentServicesIdEnum.TRAFFIC_FINES]: 'fine',
  [FrequentServicesIdEnum.TOLL]: 'toll',
  [FrequentServicesIdEnum.CHARITY]: 'donation',
  [FrequentServicesIdEnum.CREDIT]: 'service/credit/resolve',
  [FrequentServicesIdEnum.BNPL]: 'service/bnpl/resolve',
  // [FrequentServicesIdEnum.INSURANCE]: 'mini-app/insurance?referrer=dpxapp',
  [FrequentServicesIdEnum.WEALTH]: 'mini-app/wealth/home?referrer=dpxapp',
  [FrequentServicesIdEnum.BARCODE_SCANNER]: 'qr',
  [FrequentServicesIdEnum.WALLET]: 'wallet-management',
  [FrequentServicesIdEnum.PAYMENT_OF_INSTALLMENT]: 'service/credit/resolve',
  [FrequentServicesIdEnum.INSTALLMENT_PURCHASE_WITH_CHECK]: 'service/credit/resolve',
  [FrequentServicesIdEnum.MCI_MOBILE_BILL]: 'bill/identifier/11',
  [FrequentServicesIdEnum.MTN_MOBILE_BILL]: 'bill/identifier/12',
  [FrequentServicesIdEnum.RIGHTEL_MOBILE_BILL]: 'bill/identifier/13',
  [FrequentServicesIdEnum.INVESTMENT_FUNDS]: 'mini-app/wealth/investments?type=FixedIncome&referrer=dpxapp',
  // [FrequentServicesIdEnum.GOLD_FUNDS]: 'mini-app/wealth/home?referrer=dpxapp',
  [FrequentServicesIdEnum.MOLTEN_GOLD_FUNDS]: 'mini-app/wealth/investments?type=Gold',
  [FrequentServicesIdEnum.CROWDFUNDING]: 'mini-app/wealth/crowd-list?referrer=dpxapp',
  [FrequentServicesIdEnum.THIRD_PARTY_INSURANCE]: 'mini-app/insurance/vehicle/third-party?referrer=dpxapp',
  [FrequentServicesIdEnum.CAR_BODY_INSURANCE]: 'mini-app/insurance/',
  [FrequentServicesIdEnum.ELECTRICAL_DEVICES_INSURANCE]: 'mini-app/insurance/equipment/used?referrer=dpxapp',
  [FrequentServicesIdEnum.REAL_ESTATE_INVESTMENT]: 'mini-app/wealth/home?referrer=dpxapp',
};
